import {
  InnerBlocks,
  InspectorControls,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';
import { PanelBody, RangeControl, SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import { PINNED_NOTES_STARTER_NOTES } from '../_shared/pinned-note-defaults';
import { STAGGER_MODES, clampStagger } from './stagger-modes';

import './style.scss';

export default function Edit({ attributes, setAttributes }) {
  const { stagger, staggerStep } = attributes;

  const style = {};

  if (stagger !== 'none' && staggerStep) {
    style['--notes-stagger-step'] = `${staggerStep}px`;
  }

  // Clamp exactly as render.php does, so the canvas cannot show an arrangement
  // the server would have fallen back on.
  const blockProps = useBlockProps({
    className: `brandy-pinned-notes is-stagger-${clampStagger(stagger)}`,
    style,
  });

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template: PINNED_NOTES_STARTER_NOTES,
    orientation: 'horizontal',
    renderAppender: InnerBlocks.ButtonBlockAppender,
  });

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Arrangement', 'brandy-blocks')}>
          <SelectControl
            __nextHasNoMarginBottom
            label={__('Stagger', 'brandy-blocks')}
            help={__('How the notes step against each other. Flattens below 768px, where a stair no longer reads.', 'brandy-blocks')}
            value={stagger}
            options={STAGGER_MODES}
            onChange={(value) => setAttributes({ stagger: value })}
          />

          {stagger !== 'none' && (
            <RangeControl
              __nextHasNoMarginBottom
              label={__('Stagger step', 'brandy-blocks')}
              help={__('How far each note drops relative to the one before it.', 'brandy-blocks')}
              value={staggerStep}
              onChange={(value) => setAttributes({ staggerStep: value ?? 20 })}
              min={0}
              max={80}
              step={4}
              allowReset
              resetFallbackValue={20}
            />
          )}
        </PanelBody>
      </InspectorControls>

      <div {...innerBlocksProps} />
    </>
  );
}
